export const METERS_PER_MILE = 1609.344;
export const DEFAULT_IDLE_RADIUS_MILES = 0.1;

export const idleBubbleRadius = bubble => {
  const raw = bubble?.radius;
  const parsed = typeof raw === 'number' || typeof raw === 'string' ? Number(raw) : NaN;
  const hasSavedRadius = Number.isFinite(parsed) && parsed > 0;
  // Preserve the session radius field's existing miles interpretation. Parked
  // duration is a separate metric and must never change geographic coverage.
  const miles = hasSavedRadius ? parsed : DEFAULT_IDLE_RADIUS_MILES;
  return { miles, meters: miles * METERS_PER_MILE, hasSavedRadius };
};